import React, { useEffect, useRef, useState } from "react";
import { MessageLoadingAnimation } from "../../../../base/LoadingAnimation";

const ProjectLoader = ({ loading }) => {
  const [loadingText, setLoadingText] = useState("Thinking");
  const thinkingTimerRef = useRef(null);

  const startThinkingTimer = () => {
    if (thinkingTimerRef.current) clearTimeout(thinkingTimerRef.current);
    setLoadingText("Thinking");
    thinkingTimerRef.current = setTimeout(() => {
      setLoadingText("Thinking for a bit longer");
    }, 10000);
  };

  useEffect(() => {
    if (loading) startThinkingTimer();
  }, [loading]);
  return (
    <div className="stream-message-loading-height">
      <div className="loading-state mt-3 d-flex align-items-center">
        <img
          src="/assets/images/agent-loading-icon.svg"
          alt="agent-loading-icon"
          className="me-2"
        />
        <span className="light-text me-2">{loadingText}</span>
        <MessageLoadingAnimation />
      </div>
    </div>
  );
};

export default ProjectLoader;
